export default __webpack_public_path__ + "static/soehne-web-fett-6858abd3b554f63b4e09ae019aeb09cd.eot";